import {
  ClassicDataSourceType,
  ClassicModelIdentifierType,
  CogniteCadModel,
  CogniteModel,
  DataSourceType,
  DMModelIdentifierType,
  isClassicPointCloudModel,
} from '@cognite/reveal';

/**
 * Type guard to check if the given identifier is a ClassicModelIdentifierType
 */
export function isClassicModelIdentifier(
  identifier: unknown
): identifier is ClassicModelIdentifierType {
  return (
    typeof identifier === 'object' &&
    identifier !== null &&
    typeof (identifier as ClassicModelIdentifierType).modelId === 'number' &&
    typeof (identifier as ClassicModelIdentifierType).revisionId === 'number'
  );
}

/**
 * Type guard to check if the given identifier is a DMModelIdentifierType
 */
export function isDMModelIdentifier(
  identifier: unknown
): identifier is DMModelIdentifierType {
  return (
    typeof identifier === 'object' &&
    identifier !== null &&
    typeof (identifier as DMModelIdentifierType).revisionExternalId ===
      'string' &&
    typeof (identifier as DMModelIdentifierType).revisionSpace === 'string'
  );
}

export function isClassicModel(
  model: CogniteModel<DataSourceType>
): model is CogniteModel<ClassicDataSourceType> {
  return model instanceof CogniteCadModel || isClassicPointCloudModel(model);
}
